import { ModularBlockComponent } from '@commerce-webcomponents/ui-composite';
import AboutAmwayLayout from '../../../components/AboutAmwayLayout/AboutAmwayLayout';
import withNextGenISR from '../../../utils/withNextGenISR';
import { CMSTransformerDataType, PageCategory } from '../../../types/common';
import SEOComponent from '../../../components/SEOComponent/SEOComponent';
import { getContentEssentials } from 'utils/getEssentials';
import useLivePreview from 'live-preview/useLivePreview';
import { getInvalidateTime } from 'utils/common';
import { sanitizationConfig } from 'utils/sanitizationUtils';
import { TemplateType, getComponentStylesConfig } from 'utils/componentsStylingConfigs';
import withNextgenRoute from 'utils/withNextgenRoute';
import withFeatureFlags from 'utils/withFeatureFlags';

const AboutAmwayTemplate = ({ data }: CMSTransformerDataType) => {
  const header = data?.layout?.header;
  const footer = data?.layout?.footer;
  const [pageData, seoState] = useLivePreview(data, data?.seo_config);

  const componentStylesConfig = getComponentStylesConfig(TemplateType.ABOUT_AMWAY);
  return (
    <AboutAmwayLayout data={data?.navigations?.[0]} header={header} footer={footer}>
      <SEOComponent {...seoState} />
      {pageData?.content_section && (
        <ModularBlockComponent
          sanitizeComponentsConfig={sanitizationConfig}
          componentStylesConfig={componentStylesConfig}
          data={pageData.content_section}
        />
      )}
    </AboutAmwayLayout>
  );
};

export const getStaticPaths = () => ({
  paths: [],
  fallback: 'blocking', //indicates the type of fallback
});

export const getStaticProps = withNextGenISR(async (context) => {
  const { data, showError } = await getContentEssentials({
    locale: context.params?.locale as string,
    uId: 'about_amway_template',
    params: [
      {
        key: 'query',
        value: JSON.stringify({ url: `/about-amway/${context.params?.slug}` }),
      },
    ],
  });

  return {
    props: {
      data,
      showError,
      notFoundPage: !data || !Object.keys(data)?.length,
    },
    revalidate: getInvalidateTime(PageCategory.DEFERRED),
  };
});

export default withNextgenRoute<Readonly<CMSTransformerDataType>>(withFeatureFlags(AboutAmwayTemplate));
